import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Custom TranslateLoader for @ngx-translate/http-loader v17+
 * that loads translations from the default path.
 */
export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = './assets/i18n/',
    private suffix: string = '.json'
  ) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`);
  }
}

/**
 * Factory function to create a CustomTranslateHttpLoader instance
 *
 * @param http HttpClient instance
 * @returns CustomTranslateHttpLoader instance
 */
export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new CustomTranslateHttpLoader(http, './assets/i18n/', '.json');
}
